import { FileFolderEntityType, ONEServiceType } from '../objects.js';
import { ClientTreeNode } from '../../models/TreeNode';
import { isValid } from '../utilitiesmodule.js';
/**********************RICERCA*****************************************************/
ClientTreeNode.prototype.findNodeWithPath = function (path) {
    var startNode = this;
    if (startNode.path == path)
        return startNode;
    var child = startNode.children.find(res =>
        path == res.path ||
        path.startsWith(res.path + "/") ||
        path.startsWith(res.path + "\\") ||
        (path.startsWith(res.path) && res.path.endsWith("/")) ||
        (path.startsWith(res.path) && res.path.endsWith("\\"))
    );

    if (child == undefined) {
        console.writeError("Ho provato a cercare " + path + " in " + startNode.path + "ma non l'ho trovato");
        return null;
    }
    return child.findNodeWithPath(path);
}

ClientTreeNode.prototype.findNodeWithId = function (id) {
    var startNode = this;
    if (startNode.nodeID == id) return startNode;

    var indexes = id.split("-");
    if (indexes.length == 1)
        return startNode;

    indexes.shift(); //rimuove il primo elemento
    indexes = indexes.map(i => parseInt(i));
    //ogni indice indica la posizione del figlio da prendere
    var currentNode = startNode;
    indexes.forEach(i => currentNode = currentNode.children[i]);
    return currentNode;
}

ClientTreeNode.prototype.toSimpleResource = function () {
    return {
        path: this.path,
        type: this.type
    }
}

ClientTreeNode.prototype.toString = function () {
    return this.path + "?" + this.type;
}

ClientTreeNode.prototype.getParent = function () {
    var id = this.nodeID.lastIndexOf("-") == 4 //node-{numero con una cifra}
        ?
        "" :
        this.nodeID.substr(0, this.nodeID.lastIndexOf("-"));

    var parentPath = this.path.getParent();
    var parentType = this.getParentTypeByEntityType();

    return new ClientTreeNode(id, null, parentPath, parentType);
}

ClientTreeNode.prototype.hasParent = function () {
    return this.nodeID != "node" && this.nodeID.lastIndexOf("-") != 4;
}

ClientTreeNode.prototype.getTemplate = function (checked) {
    var shortPath = this.getShortPath();
    var icon = this.type.getMetroIcon(this.path);
    var checkedProperty = checked ?
        " checked " :
        " ";
    var isSelectable = this.type.isEntityTypeSelectable();
    var template = "<div class='d-flex flex-align-center'>";
    if (isSelectable) {
        template += "<input type='checkbox' data-role='checkbox' id='checkbox-" + this.nodeID + "'" + checkedProperty + ">";
    }

    template += "<label><span class='" + icon + " mx-1'></span><span class='mx-1'>" + shortPath + "</span></label>";
    template += "</div>";
    return template;
}

ClientTreeNode.prototype.getTemplateForSingleChoice = function (checked) {
    var shortPath = this.getShortPath();
    var icon = this.type.getMetroIcon(this.path);
    var checkedProperty = checked ?
        " checked " :
        " ";

    var isSelectable = this.type.isEntityTypeSelectable();

    var template = "<div class='d-flex flex-align-center'>";
    if (isSelectable) {
        template += "<input name='node' type='radio' data-role='radio' id='checkbox-" + this.nodeID + "'" + checkedProperty + ">";
    }

    template += "<label><span class='" + icon + " mx-1'></span><span class='mx-1'>" + shortPath + "</span></label>";
    template += "</div>";
    return template;
}

ClientTreeNode.prototype.getShortPath = function () {
    var shortPath = "";
    var slash = [FileFolderEntityType.FN_Folder, FileFolderEntityType.FN_File].includes(this.type) ?
        "\\" : "/";

    if (this.path.indexOf(slash) != -1) {
        shortPath = this.path.split(slash).pop();
    } else if (this.path.indexOf("?") != -1) {
        shortPath = this.path.split("?")[0];
    } else {
        shortPath = this.path;
    }

    if (slash == "\\" && shortPath.endsWith(":")) {
        shortPath += "\\";
    }

    return shortPath;
}


ClientTreeNode.prototype.insertParentsInto = function (inputNodes, platformType) {
    if (!isValid(inputNodes))
        inputNodes = [];

    var parentsPaths = this.path.getAllPaths(platformType);
    parentsPaths.splice(-1, 1);
    parentsPaths.forEach(p => {
        if (inputNodes.findIndex(n => n.path == p) == -1)
            inputNodes.push(new ClientTreeNode(null, null, p, this.getParentType(platformType)));
    });

    return inputNodes;
}

ClientTreeNode.prototype.getParentType = function (platformType) {
    if ([ONEServiceType.FileFolder, ONEServiceType.Network].includes(platformType))
        return FileFolderEntityType.FN_Folder;
    if (platformType == 2)
        return FileFolderEntityType.FTP_Folder;
    //childpath è la prima cartella
    if (this.path.indexOf("/") == -1) {
        return platformType == ONEServiceType.Microsoft_SharePoint ?
            FileFolderEntityType.SP_Site_All :
            FileFolderEntityType.Cloud_Root;
    }
    var nFolders = this.path.split("/").length;
    if (nFolders == 2)
        switch (platformType) {
            case ONEServiceType.Microsoft_SharePoint:
                return FileFolderEntityType.SP_Site;
            case ONEServiceType.Cloud_AmazonS3Storage:
            case ONEServiceType.Cloud_S3CompatibleStorage:
            case ONEServiceType.Cloud_IperiusS3Storage:
            case ONEServiceType.Cloud_AzureBlob:
            case ONEServiceType.Cloud_AzureFile:
                return FileFolderEntityType.Cloud_Bucket;
            default:
                return FileFolderEntityType.Cloud_Folder;
        }


    if (nFolders == 3 && platformType == ONEServiceType.Microsoft_SharePoint)
        return FileFolderEntityType.SP_Library;


    return platformType == ONEServiceType.Microsoft_SharePoint ?
        FileFolderEntityType.SP_Folder :
        platformType == ONEServiceType.FTP ?
            FileFolderEntityType.FTP_Folder :
            FileFolderEntityType.Cloud_Folder;
}

ClientTreeNode.prototype.getParentTypeByEntityType = function () {
    var nParts_parent = this.nParts - 1;
    switch (this.type) {
        case FileFolderEntityType.FN_File:
        case FileFolderEntityType.FN_Folder:
            if (nParts_parent == 1)
                return FileFolderEntityType.DiskPartition;
            return FileFolderEntityType.FN_Folder;

        case FileFolderEntityType.Cloud_File:
        case FileFolderEntityType.Cloud_Folder:
            return FileFolderEntityType.Cloud_Folder;

        case FileFolderEntityType.SP_File:
        case FileFolderEntityType.SP_Folder:
            if (nParts_parent == 1)
                return FileFolderEntityType.SP_Site;
            if (nParts_parent == 2)
                return FileFolderEntityType.SP_Library;
            return FileFolderEntityType.SP_Folder;

        case FileFolderEntityType.SP_Site:
            return FileFolderEntityType.SP_Site_All

        case FileFolderEntityType.SP_Library:
            return FileFolderEntityType.SP_Site;
        case FileFolderEntityType.MT_Team:
            return FileFolderEntityType.MT_Team_AllTeams

        case FileFolderEntityType.MT_Channel:
            return FileFolderEntityType.MT_Team;

        case FileFolderEntityType.FTP_File:
        case FileFolderEntityType.FTP_Folder:
            return FileFolderEntityType.FTP_Folder;

        case FileFolderEntityType.MT_Team_All:
            return FileFolderEntityType.MT_Team_All;

        case FileFolderEntityType.Mailbox_User:
        case FileFolderEntityType.Mailbox_Impersonation:
        case FileFolderEntityType.Mailbox_Group:
        case FileFolderEntityType.Mailbox_Shared:
            return FileFolderEntityType.Mailbox_All;

    }

}

ClientTreeNode.prototype.isFile = function () {
    return this.type.isFile();
}

ClientTreeNode.prototype.isChildOf = function (parentNodeMaybe, slash = null) {
    if (parentNodeMaybe == null) {
        return this.nParts == 1;
    }
    if (slash == null) {
        slash = this.path.getSeparator();
    }

    return this.path.startsWith(parentNodeMaybe.path + slash) && this.nParts == (parentNodeMaybe.nParts + 1)
}

ClientTreeNode.prototype.buildLiteTree = function () {
    var liteNode = {
        resID: this.resID,
        path: this.path,
        type: this.type
    }

    if (this.children == null) {
        liteNode.children = null;
        return liteNode;
    }

    liteNode.children = [];

    this.children.forEach(childNode => {
        liteNode.children.push(childNode.buildLiteTree());
    })

    return liteNode;
}